import { Fragment } from "react";
import { isString } from "lodash";
import PropTypes from "prop-types";

const RemainingPanel = ({ groups, labels, saving, onGo, onCreate }) => (
  <aside
    aria-labelledby="onboarding-remaining-title"
    className="onboarding__panel"
  >
    <h2 id="onboarding-remaining-title" className="onboarding__panel-title">
      {labels.TITLE}
    </h2>
    <div className="onboarding__count">
      <strong>
        {groups.reduce((count, group) => count + group.items.length, 0)}
      </strong>
      <span>{labels.COUNT}</span>
    </div>
    {groups.map((group) => (
      <div key={group.step} className="onboarding__group">
        <button
          type="button"
          className="onboarding__group-link"
          onClick={() => onGo(group.index)}
        >
          {group.title}
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="m9 18 6-6-6-6" />
          </svg>
        </button>
        <ul className="onboarding__dots">
          {group.items.map((item) => {
            const { text, detail, tone } = isString(item)
              ? { text: item }
              : item;
            return (
              <li
                key={text}
                className={tone ? `onboarding__dot--${tone}` : undefined}
              >
                <span className="onboarding__dot-text">
                  {text}
                  {detail ? (
                    <span className="onboarding__dot-detail">
                      {detail.map((part, index) => (
                        <Fragment key={part}>
                          {index > 0 ? " · " : null}
                          <span>{part}</span>
                        </Fragment>
                      ))}
                    </span>
                  ) : null}
                </span>
              </li>
            );
          })}
        </ul>
        {group.action}
      </div>
    ))}
    {labels.NOTE ? <p className="onboarding__note">{labels.NOTE}</p> : null}
    {onCreate ? (
      <button
        type="button"
        className="onboarding__button onboarding__button--primary onboarding__button--block"
        disabled={saving}
        onClick={onCreate}
      >
        {saving ? labels.CREATING : labels.CREATE}
      </button>
    ) : null}
  </aside>
);

RemainingPanel.propTypes = {
  groups: PropTypes.arrayOf(PropTypes.object).isRequired,
  labels: PropTypes.object.isRequired,
  saving: PropTypes.bool,
  onGo: PropTypes.func.isRequired,
  onCreate: PropTypes.func,
};

RemainingPanel.defaultProps = {
  saving: false,
  onCreate: null,
};

export default RemainingPanel;
